import { language } from '../global'
import precoSaNamSniva from './blog/preco-sa-nam-sniva'
import akoZlepsitSpanok from './blog/ako-zlepsit-spanok'
import lucidneSnivanie from './blog/lucidne-snivanie'

export const POSTS = [
  precoSaNamSniva[language as keyof typeof precoSaNamSniva],
  akoZlepsitSpanok[language as keyof typeof akoZlepsitSpanok],
  lucidneSnivanie[language as keyof typeof lucidneSnivanie],
]
